<div class="grid mt-0">
    <div class="col-12 pt-0">
        <p-tabView [scrollable]="true" [activeIndex]="permissionTabIndex" (onChange)="changeTab($event)" styleClass="transparent-tabView">
            <p-tabPanel header="{{ 'PERMISSIONS' | translate }}">
                <div class="col-12 pt-0">
                    <app-permissions-list-filters></app-permissions-list-filters>
                </div>
                <div class="col-12 card border-round">
                    <app-permissions-list></app-permissions-list>
                </div>
            </p-tabPanel>
            <p-tabPanel header="{{ 'CALENDAR' | translate }}">
                <app-permissions-calendar></app-permissions-calendar>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>